<template>
  <v-dialog
    v-model="showDialog"
    max-width="660"
    @click:outside="cancelDialog"
    content-class="delete-dialog"
  >
    <v-card>
      <v-card-title>
        <h3>Create Snapshot</h3>
      </v-card-title>

      <v-card-text>
        <p v-if="status.toLowerCase() === 'running'"><strong>It's better to stop the environment before creating a snapshot.</strong></p>
        <p>Snapshots will add to your overall cost</p>

        <v-text-field
          v-model="snapshotName"
          label="Snapshot name"
          name="snapshotName"
          :value="snapshotNameWithDatetime"
          type="text"
          class="snapshot-input"
        ></v-text-field>
        <v-text-field
          v-model="description"
          label="Description"
          name="description"
          type="text"
          class="snapshot-input"
        ></v-text-field>
      </v-card-text>

      <v-card-actions class="justify-center buttons">
        <v-btn text @click="cancelDialog">Cancel</v-btn>

        <v-btn color="success darken-1" @click="confirmDialog" :disabled="loading">
          <v-icon left v-if="!loading">fas fa-camera</v-icon>
          <v-icon left v-else>fas fa-spinner fa-spin</v-icon>Create snapshot
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    snapshotName: "",
    description: "",
    currentTime: "",
    loading: false,
  }),
  props: ["showCreateSnapshotDialog", "environmentName", "status"],
  watch: {
    showCreateSnapshotDialog() {
      this.clearForm();
      this.getCurrentTime();
      this.loading = false;
    },
  },
  computed: {
    snapshotNameWithDatetime() {
      return (this.snapshotName = `${this.environmentName} ${this.currentTime}`);
    },
    showDialog: {
      get() {
        return this.showCreateSnapshotDialog;
      },
      set(value) {
        this.$emit('update:showCreateSnapshotDialog', value)
      } 
    }
  },
  methods: {
    cancelDialog() {
      this.showDialog = false;
    },
    confirmDialog() {
      this.loading = true;

      const data = {
        snapshotName: this.snapshotName,
        description: this.description,
      };

      this.$emit("confirmCreateSnapshotDialog", data);
    },
    clearForm() {
      this.description = "";
    },
    getCurrentTime() {
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

      this.currentTime = `${date} ${time}`;
    },
  },
};
</script>

<style scoped>
.delete-dialog h3,
p,
input,
.snapshot-input {
  font-family: "Montserrat";
  text-align: center;
}

.delete-dialog h3 {
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
}

.delete-dialog p {
  font-weight: 500;
}

.delete-dialog p:nth-child(2) {
  margin-top: -15px;
}

.delete-dialog .buttons {
  padding-bottom: 60px;
}
</style>